module.exports = __webpack_public_path__ + "img/order-open-positions.422a29aa.svg";